import Vue from 'vue'
import cancellationUrlWithError from '~utils/psp-cancellation'

export default Vue.extend({
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    backToLHLink(): string {
      return cancellationUrlWithError(this.$store.state.redemptions.redemption?.cancellationUrl, 'USER_CANCELLATION')
    },
  },
})
